module.exports = __webpack_public_path__ + "public/images/generated-essay-writing.770f24e413038a05afae6a1a995d82cb.jpg";